<template>
  <b-row id="wellness" class="section-invert reverse-sm">
    <b-col md="12" lg="6">
      <div class="col-bg ml-lg-auto"></div>
    </b-col>
    <b-col md="12" lg="6" class="content my-auto">
      <h3>{{ $t('wellness.title') }}</h3>
      <p class="text-info">
        {{ $t('wellness.subtitle')}}
      </p>
      <div class="subtitle">
        <div class="subtitle-list subtitle-list mt-sm-5">
          <div>
            <p><v-icon large v-text="'mdi-meditation'"></v-icon>{{ $t('wellness.mindfulness') }}</p>
          </div>
          <div>
            <p><v-icon large v-text="'mdi-yoga'"></v-icon>{{ $t('wellness.pilates') }}</p>
          </div>
          <div>
            <p><v-icon large v-text="'mdi-run'"></v-icon>{{ $t('wellness.cardio') }}</p>
          </div>
          <div>
            <p><v-icon large v-text="'mdi-walk'"></v-icon>{{ $t('wellness.healthy-back') }}</p>
          </div>
          <div>
            <p><v-icon large v-text="'mdi-food-apple'"></v-icon>{{ $t('wellness.nutrition') }}</p>
          </div>
          <div>
            <p><v-icon large v-text="'mdi-spa'"></v-icon>{{ $t('wellness.vitality') }}</p>
          </div>
        </div>
      </div>
      <router-link to="/opensaludprime/bienestar" class="mt-4">
             <base-button style="color:white" class="btn-more-info-white" white outline href=""><span style="color:white">{{ $t('more-info-btn') }}</span></base-button>
      </router-link>
            </b-col>
  </b-row>
</template>

<script>
export default {
}
</script>

<style lang="scss">
  @import "../../../static-appopensalud/css/public/layout.scss";
  #wellness {
    margin-top: 0px;
  }
  #wellness .col-bg {
    background-image: url(/static-appopensalud/img/bgs/wellness.jpg),
      linear-gradient(273deg, #ffffff96, transparent);
    background-position: center;
    background-blend-mode: overlay;
  }
  @media (max-width: 1268px) {
    #wellness > div.content.my-auto.col-md-12.col-lg-6 > div > div > div > p {
      font-size: 1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/OpenSaludWellness.vue